export var ImagePosition;
(function (ImagePosition) {
  ImagePosition["Before"] = "Before";
  ImagePosition["After"] = "After";
  ImagePosition["Behind"] = "Behind";
})(ImagePosition || (ImagePosition = {}));